module.exports = __webpack_public_path__ + "static/2-ef872b426cace16b75853c4f51be1c66.jpg";